import React, { useState, useContext } from 'react';
import styled from 'styled-components'
import Input from '../../../../../components/input'
import Button from '../../../../../components/button'
import { Toggle } from '../../overview/components/toggle'
import ProfileIcon from '@material-ui/icons/AccountCircle';
import { AuthContext } from '../../../../../auth-context'
import { updatePortalUser } from '../../../../../api'
import { DashboardContext } from '../../../dashboard-context'
import { ErrorMessage } from '../../../../../components/error-message';

const Container = styled.div`
  background: #FFF;
	border-radius: 8px;
	box-shadow: 0px 0px 8px 0px #e1e2e6;
  width: 100%;
  padding: 24px;

  @media(max-width: 900px) {
    padding: 16px;
  }
`;

const Label = styled.label`
  color: #555;
  display: flex;
  align-items: center;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 24px;

  svg {
    fill: #555;
    height: auto;
    width: 36px;
    margin-right: 16px;
  }

  @media(max-width: 900px) {
    font-size: 1.25rem;
    margin-bottom: 16px;

    svg {
      width: 28px;
    }
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;

  @media(max-width: 900px) {
    margin-top: 16px;
  }
`;

const AddButton = styled(Button)`
  margin: 0;
  margin-left: 16px;
  min-width: 180px;
`;

const Profile = (props) => {
  const { openSnackbar } = useContext(DashboardContext);
  const { user } = useContext(AuthContext);
  const [email, updateEmail] = useState(user.email_address)
  const [name, updateName] = useState(user.name)
  const [phone, updatePhone] = useState(user.phone_number)
  const [hideTracker, updateHideTracker] = useState(user.hide_tracker)

  const [emailError, updateEmailError] = useState(false)
  const [nameError, updateNameError] = useState(false)
  const [phoneError, updatePhoneError] = useState(false)
  const emailIsValid = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  const handleErrors = () => {
    updateEmailError(false);
    updateNameError(false);
    updatePhoneError(false);
  }

  const handleSubmit = (e) => {
    if(email === '' && !emailIsValid(email))
      updateEmailError(true)
    else if(name === '')
      updateNameError(true)
    else {
      if(name !== '' && email !== '') {
        updatePortalUser(user.id, 
          { 
            email_address: email,
            name: name,
            phone_number: phone,
            hide_tracker: hideTracker,
          }
        ).then(() => {
          openSnackbar('Account was successfully updated.', false)
          handleErrors()
        }).catch((err) => {
          openSnackbar('There was a problem updating your account info.', true)
        });
      }
    }
  }
  
  return (
    <React.Fragment>
      <Container className={props.className}>
        <Label>
          <ProfileIcon /> Profile
        </Label>
        <Input
          error={emailError}
          label="Email"
          type="email" 
          autoComplete="email" 
          value={email}
          onChange={updateEmail}
        />
        <Input
          error={nameError}
          label="Full Name"
          value={name}
          onChange={updateName}
        />
        <Input
          error={phoneError}
          label="Phone"
          value={phone}
          onChange={updatePhone}
        />
        {user.matching_user_id && (
          <Toggle
            label="Hide tracker from friends"
            checked={hideTracker === 1}
            onChange={() => updateHideTracker(1 - hideTracker)}
          />
        )}
        {(emailError || nameError || phoneError) && 
          <ErrorMessage>
            Email/Name/Phone number is invalid or missing
          </ErrorMessage>
        }
        <ButtonContainer>
          <AddButton 
            label="Update profile"
            onClick={handleSubmit}
          />
        </ButtonContainer>
      </Container>
  </React.Fragment>
  )
}

export default Profile